




































































import AgencyCreate from '@/components/Agencies/AgencyCreate.vue';
import AgencyDto from '@/models/Agencies/AgencyDto'
import { Component, Vue } from 'vue-property-decorator'
import { AgencyModule } from '@/store/modules/agency';
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'

@Component({
  name: 'AgencyList',
  components: { AgencyCreate, Alert }
})
export default class extends GiganautVue {
  
  async navigateToAgency(item: AgencyDto) {
    const agencyId = item.id;
    await AppModule.getAgencyContext(agencyId);
    this.$router.push({ name: PageNames.SysAdminAgencyDetails, params: { agencyid: agencyId } });
  }

  get agencies() {
    return AgencyModule.agencies;
  }

  get loading() {
    return AgencyModule.loadingAgencies;
  }

  created() {
    this.getAgencies();
  }

  async getAgencies() {
    AgencyModule.getAgencies();
  }

  private search = '';
  
  private headers = [
    // { text: '', value: 'avatar' },
    { text: 'Brand Name', value: 'brandName' },
    { text: 'Email Address', value: 'emailAddress' },
    { text: 'Phone Number', value: 'phoneNumber' },
    { text: 'Website', value: 'website' },
  ]
}
